const { rem: { parseStyle } } = require('@futuweb/fego-bridge');

export default {
    props: {
        tpl: {}
    },
    computed: {
        rootClass() {
            let r = [];
            let { autoWidth, autoHeight } = this.tpl.props || {};
            if (autoWidth) {
                r.push(" auto-width");
            }

            if (autoHeight) {
                r.push("auto-height");
            }

            return r;
        }
    },
    methods: {
        setStyle(tpl) {
            let { style } = tpl;
            return style && parseStyle(style);
        }
    },
};



// WEBPACK FOOTER //
// ./src/sdk/container/common.js